export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sucesso"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erro"])}
}